import { configureStore } from '@reduxjs/toolkit';
import gameReducer from '../components/Game/gameSlice';
import cardPreviewReducer from '../components/Card/previewSlice';
import tooltipSliceReducer from '../components/Tooltip/tooltipSlice';
import cardSetReducer from '../components/Card/cardSetSlice';
import diceReducer from '../components/Dice/diceSlice';
import emojiReducer from '../components/Emoji/emojiSlice';
import userReducer from '../components/User/userSlice';
import gameListReducer from '../components/Matchmaking/gameListSlice';
import socketMiddleware from '../components/middleware/socketMiddleware';

export const store = configureStore({
  reducer: {
    game: gameReducer,
    cardPreview: cardPreviewReducer,
    cardSet: cardSetReducer,
    dice: diceReducer,
    emoji: emojiReducer,
    user: userReducer,
    gameList: gameListReducer,
    tooltip: tooltipSliceReducer,
  },

  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat([
      //loggerMiddleware,
      socketMiddleware,
    ])
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store
